import { getAuth, signOut } from 'firebase/auth';

/**
 * Déconnexion « propre ».
 *
 * `signOut()` invalide immédiatement le token Firestore : tout listener/getDoc
 * encore actif sur `users/{uid}` reçoit alors un `permission-denied` avant que
 * React n'ait eu le temps de re-rendre avec `user = null` et de désabonner les
 * effects. On prévient donc l'AuthProvider AVANT (`AUTH_BEFORE_LOGOUT_EVENT`),
 * on laisse React committer + exécuter les cleanups, puis seulement on signOut.
 */
export const AUTH_BEFORE_LOGOUT_EVENT = 'focuspips:before-logout';

const nextTick = () => new Promise<void>((resolve) => setTimeout(resolve, 0));

export async function signOutCleanly(): Promise<void> {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event(AUTH_BEFORE_LOGOUT_EVENT));
    // Deux ticks : commit React (flushSync côté provider) puis passive effects cleanup.
    await nextTick();
    await nextTick();
  }
  await signOut(getAuth());
}
